import Box from '@talkdesk/cobalt-react-box'
import Flex from '@talkdesk/cobalt-react-flex'

export const Center = ({ children }) => (
  <Flex
    direction='column'
    alignX='center'
    alignY='start'
    padding='4'
    width='100%'
  >
    <Flex width='380px' grow>
      <Box paddingY='4' width='100%'>
        {children}
      </Box>
    </Flex>
  </Flex>
)
